import React from 'react';
import { TextField } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { MAX_SPEAKER_NAME_LENGTH, defaultSpeakerName } from '../../utils/speakerActivity';

interface SpeakerNameFieldProps {
  angleKey: string;
  /** The angle's label: the name used when this is left empty. */
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

/** Who's on an angle, for naming their lines in the transcript (multicam set-up). */
const SpeakerNameField: React.FC<SpeakerNameFieldProps> = ({ angleKey, label, value, onChange, disabled, sx }) => (
  <TextField
    size="small"
    label="Who’s on this camera"
    value={value}
    onChange={(event) => onChange(event.target.value)}
    placeholder={defaultSpeakerName({ angleKey, label })}
    helperText="Names their lines in the transcript."
    disabled={disabled}
    inputProps={{ maxLength: MAX_SPEAKER_NAME_LENGTH, 'aria-label': `Who’s on angle ${angleKey}` }}
    InputLabelProps={{ shrink: true }}
    sx={sx}
  />
);

export default SpeakerNameField;
